module.exports = __webpack_public_path__ + "img/sixpackcarrier20.f2f9b84f.jpg";